import './WeightedValuesTable.css';

import React from 'react';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';

const WeightedValuesTable = ({ qualitativeWeightedValues }) => {

    const headers = [
        { label: 'Value', align: 'left' },
        { label: 'Weigth', align: 'center' },
    ];

    const rows = qualitativeWeightedValues ? qualitativeWeightedValues.map((weightedValue) => ({
        id: weightedValue.qualitativeWeightedValueId,
        cells: [
            { content: `${weightedValue.label}`, align: 'left' },
            { content: `${weightedValue.weight}`, align: 'center' },
        ]
    })) : [];
    // console.log('qualitativeWeightedValues', qualitativeWeightedValues);

    return (
        (qualitativeWeightedValues && qualitativeWeightedValues.length > 0 &&
            < B2BTableInMemory
                headers={headers} rows={rows}
                className={"qualitative-weighted-values-list-table"}
                numRows={10}
                stickyHeader={true}
            />
        )
    );
};

export default WeightedValuesTable;